import { Link, useLocation } from "react-router-dom";

import { WorkBgFour, WorkBgOne, WorkBgThree, WorkBgTwo } from "./components";
import "./works.scss";

const Works = ({ portfolios, type }) => {
  let location = useLocation();

  const workBg2_3 = () => {
    return (
      <>{location.pathname === "/home" ? <WorkBgTwo /> : <WorkBgFour />}</>
    );
  };

  return (
    <div id="works">
      <div className="container">
        <div className="title">
          <h5 className="text-center font_change_color">My Portfolio</h5>
          <h1 className="text-center">{type ? "Works" : "Recent Work"}</h1>
        </div>
        <div>
          {portfolios.map((portfolio, i) => {
            return (
              <div key={i}>
                {type ? (
                  <div className="portfolio_type mb-4">
                    <h2 className="font-weight-bold font_change_color">
                      {portfolio.type} :{" "}
                    </h2>
                  </div>
                ) : null}
                <div
                  className={
                    type
                      ? "row d-flex justify-content-start m-0"
                      : "row d-flex justify-content-center m-0"
                  }
                  key={i}
                >
                  {portfolio.ps.map((p, j) => {
                    return (
                      <div
                        className="col-12 col-sm-6 col-md-6 col-lg-4"
                        key={i + "_" + j}
                      >
                        <a
                          href={p.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="card">
                            <img src={p.img} alt="portfolio_img" />
                          </div>
                        </a>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        {!type ? (
          <div className="btn_block w-100 d-flex justify-content-center">
            <Link to="/portfolio" className="btn btn-change-outline-color">
              All Project
            </Link>
          </div>
        ) : null}
        {portfolios.length === 1 ? <WorkBgOne /> : null}
      </div>
      {portfolios.length > 1 ? workBg2_3() : null}
      <WorkBgThree />
    </div>
  );
};

export default Works;
